import { css } from "@emotion/core";
import { tokens, applyFont } from "@domain-group/fe-brary";
var SizeValues = {
  small: {
    paddingHorizontal: "4px",
    gap: "5px",
    badgeFont: tokens.typography.miniBold
  },
  medium: {
    paddingHorizontal: "4px",
    badgeFont: tokens.typography.miniBold,
    gap: "5px"
  },
  large: {
    paddingHorizontal: "12px",
    badgeFont: tokens.typography.miniBold,
    gap: "5px"
  }
};
var colourStyle = (bgColour, color) => /*#__PURE__*/css("color:", color, ";background-color:", bgColour, ";");
var sizeStyle = size => {
  var _SizeValues$size = SizeValues[size],
    paddingHorizontal = _SizeValues$size.paddingHorizontal,
    paddingVertical = _SizeValues$size.paddingVertical,
    badgeFont = _SizeValues$size.badgeFont;
  return /*#__PURE__*/css(applyFont(badgeFont), " padding:", paddingVertical !== null && paddingVertical !== void 0 ? paddingVertical : 0, " ", paddingHorizontal, ";");
};
export var wrapper = size => {
  var _SizeValues$size2 = SizeValues[size],
    paddingVertical = _SizeValues$size2.paddingVertical,
    badgeFont = _SizeValues$size2.badgeFont;
  return /*#__PURE__*/css(applyFont(badgeFont), ";display:flex;align-items:center;flex-wrap:wrap;overflow:hidden;height:calc( ", badgeFont.lineHeight, " + ", paddingVertical ? "(".concat(paddingVertical, " * 2) + ") : '', " 2px );gap:5px;opacity:0.9;");
};
export var badge = function badge(badgeEnum) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "medium";
  var bgColour = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : badgeEnum.colour;
  var color = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : badgeEnum.textColour || tokens.colors.neutral.heavy.default;
  return /*#__PURE__*/css(colourStyle(bgColour, color), ";", sizeStyle(size), ";border-radius:", tokens.borderRadius.mini, ";");
};